import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ConfigurationContext } from './configuration-context'
import { getPortalConfiguration } from 'services/portal-configuration'
import { DEFAULT_PORTAL_CONFIGURATION } from 'services/default-portal-configuration'
import config from 'config'

class ConfigurationProvider extends Component {
  state = {
    portalConfiguration: null,
  }

  getPortalConfiguration = () => {
    getPortalConfiguration(this.mustForceProduction())
      .then(response => {
        const portalConfiguration = this.applyModifiers(response.data)
        window.parent.postMessage({ type: 'portalConfigurationReceived', data: portalConfiguration }, '*')
        this.setState({ portalConfiguration })
      }).catch(e =>
        this.setState({ portalConfiguration: DEFAULT_PORTAL_CONFIGURATION })
      )
  }

  mustForceProduction = () => {
    if (typeof (URLSearchParams) !== 'undefined') {
      const params = new URLSearchParams(window.location.search.slice(1))
      return params.get('force_production') || false
    }
    return false
  }

  listenMessages = () => {
    window.addEventListener('message', this.onMessageReceived, false)
    if (window.parent) window.parent.postMessage({ type: 'portalConfigurationReady' }, '*')
  }

  onMessageReceived = e => {
    if (e.data && e.data.type === 'updatePortalConfiguration') {
      this.setState({ portalConfiguration: this.applyModifiers(e.data.data) })
    }
  }

  applyModifiers = configuration => {
    const modifiers = config.get('PORTAL_CONFIGURATION_MODIFIERS')

    if (Array.isArray(modifiers)) {
      modifiers.forEach(modifier => modifier(configuration))
    }

    return configuration
  }

  componentDidMount() {
    this.getPortalConfiguration()
    this.listenMessages()
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessageReceived)
  }

  render() {
    return (
      <ConfigurationContext.Provider value={this.state.portalConfiguration}>
        {typeof this.props.children === 'function'
          ? this.props.children(this.state.portalConfiguration)
          : this.props.children
        }
      </ConfigurationContext.Provider>
    )
  }
}

ConfigurationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ])
}

export default ConfigurationProvider
